module.exports = __webpack_public_path__ + "static/media/leather.4930131c.png";